import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["submit_btn"]

  enableSubmit() {
    this.submit_btnTarget.classList.remove('disabled')
  }
}
